import React from 'react';
import { Device } from 'DeviceUtils';
import { View } from 'react-native';
import { availablePageNames } from '../Page';
import { topTabBarOptions, topTabBarOptionsWeb } from './navigationOptions';
import { pageTypeEnum, menuItemsStackFactory } from './menuItemsStackFactory';
import TabBarComponent from './tabBar';
import customMenuItems from './customMenuItems';
import { IconFilter, IconMenu, iconSearch } from './navigationHeaderIcons';
import { extendMenuItems, extendPageReferenceFromExtension } from './pageExtensionUtils';

const isUnderLineItemInMenu = (item) =>
    item.type === pageTypeEnum.TEXT_PAGE || item.type === pageTypeEnum.SETTINGS;

const modifyTopBarOptions = (options, itemsLength = 0) => {
    const modifiedOptions = { ...options };

    if (itemsLength > 0) {
        modifiedOptions.tabBarScrollEnabled = true;
        modifiedOptions.style = {
            ...modifiedOptions.style,
            minWidth: Device.isTablet ? 400 : null,
            width: 'auto'
        };
        modifiedOptions.screenOptions.tabBarLabelStyle = {
            ...modifiedOptions.screenOptions.tabBarLabelStyle,
            minWidth: `${Math.floor(100 / (itemsLength + 1))}%`
        };
    }

    return modifiedOptions;
};

const getMaterialTopBarOptionsBase = (itemsLength) => ({
    ...modifyTopBarOptions(topTabBarOptions, itemsLength)
});

const getMaterialTopBarOptionsWeb = (itemsLength, haveTitle) => ({
    ...modifyTopBarOptions(topTabBarOptionsWeb, itemsLength),
    tabBar: (props) => (
        <TabBarComponent
            {...props}
            getAccessibilityLabel={({ route }) => route.name}
            getLabelText={({ navigation, route }) => {
                const { options } = props.descriptors[route.key];
                return options?.tabBarLabel || route.name;
            }}
            getTestID={({ route }) => route.name}
            labelStyle={topTabBarOptionsWeb.labelStyle}
            inactiveLabelStyle={topTabBarOptionsWeb.inactiveLabelStyle}
            activeBackgroundColor={topTabBarOptionsWeb.activeBackgroundColor}
            inactiveBackgroundColor={topTabBarOptionsWeb.inactiveBackgroundColor}
            haveTitle={haveTitle}
        />
    )
});

const getMaterialTopBarOptions = (itemsLength, haveTitle = false) =>
    Device.isWeb
        ? getMaterialTopBarOptionsWeb(itemsLength, haveTitle)
        : getMaterialTopBarOptionsBase(itemsLength);

const createNavigationOptionsBase = (options, navigation) => ({
    headerTitle: options.label.toUpperCase(),
    headerTitleAlign: 'center',
    headerLeft: IconMenu,
    headerRight: () =>
        // options.slug === 'videostore' ? (
        //     <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        //         {IconFilter(navigation)}
        //         {iconSearch}
        //     </View>
        // ) : (
        iconSearch
    // )
});

// No default header for web
const createNavigationOptionsWeb = () => ({
    headerShown: false
});

const createNavigationOptions = (options, navigation) =>
    Device.isWeb ? createNavigationOptionsWeb() : createNavigationOptionsBase(options, navigation);

const remapMissingScreen = (slug, type) => {
    let screen = String(slug);
    if (availablePageNames && availablePageNames.indexOf(slug) !== -1) {
        if (type === 'textPage' && slug === 'settings') {
            screen = 'settings';
        }
    }

    return screen;
};

const IconMapping = {
    dashboard: 'nav_home',
    'new-movies': 'film',
    'live-tv': 'nav_tvguide',
    search: 'search',
    plus: 'heart',
    'rewind-2': 'history',
    'all-movies': 'nav_videostore',
    settings: 'nav_settings',
    menu: 'nav_mycontent'
};

const prepareMenuItems = (menu) => {
    const items = [];
    const routes = {};
    // Extend menu items with custom data
    const menuItems = extendMenuItems(menu.items, customMenuItems);

    menuItems.forEach((item) => {
        const menuItem = { ...item };
        menuItem.title = item.label;
        menuItem.path = remapMissingScreen(item.slug, item.type);
        menuItem.icon = IconMapping[item.icon] || 'film';

        routes[menuItem.path] = {
            rootStack: menuItemsStackFactory(item),
            requiresLogin: item.requiresLogin
        };
        const routeOptions = routes[item.slug];
        routeOptions.route = item.slug;
        // routeOptions.title = item.label.toUpperCase();

        items.push(menuItem);
    });

    return {
        items,
        routes
    };
};

export {
    prepareMenuItems,
    modifyTopBarOptions,
    isUnderLineItemInMenu,
    getMaterialTopBarOptions,
    createNavigationOptions,
    extendPageReferenceFromExtension
};
